
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/messages",
      function () {
        return require("private-next-pages/messages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/messages"])
      });
    }
  